import React from 'react';
import { COLORS, SPACING } from '../styles/theme';

export function Modal({ title, onClose, children }: { title: string; onClose: () => void; children: React.ReactNode }) {
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1000,
        background: 'rgba(0,0,0,0.75)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: SPACING.lg,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          width: 'min(520px, 100%)',
          maxHeight: '85vh',
          display: 'flex',
          flexDirection: 'column',
          background: COLORS.panel,
          border: `2px outset ${COLORS.highlight}`,
        }}
      >
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: COLORS.accent,
          color: '#fff',
          padding: `${SPACING.xs} ${SPACING.sm}`,
          fontSize: '9px',
          fontWeight: 700,
          borderBottom: `2px solid ${COLORS.highlight}`,
          userSelect: 'none',
        }}>
          <span style={{ textTransform: 'uppercase', letterSpacing: '0.06em', fontFamily: '"IBM Plex Mono", monospace' }}>{title}</span>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: '#fff',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 700,
              lineHeight: 1,
              padding: 0,
            }}
          >
            ✕
          </button>
        </div>
        <div style={{ overflowY: 'auto', flex: 1 }}>
          {children}
        </div>
      </div>
    </div>
  );
}
